// extracted by mini-css-extract-plugin
export var main = "b0100dca4b4bd4d6c8dd933b4c36ad71-css";